import React from 'react';
import { GoogleMap, LoadScript, Marker, OverlayView } from '@react-google-maps/api';
import { console_log } from '../helpers/untils';

const defaultPosition = {
  lat: 0,
  lng: 0
};

const DeviceMarker = (props) => {
  const {
    position = defaultPosition,
    label,
    clusterer,
    marker,
    onClick,
    currentDeviceData = {}
  } = props

  // Replace "path/to/custom-marker.png" with the path to your custom marker image
  const customMarkerIcon = {
    url: marker?.data?.category ? `/images/icon/${marker?.data?.category}.svg` : `/images/icon/Bus.svg`,
    scaledSize: new window.google.maps.Size(30, 30),
    origin: new window.google.maps.Point(0, 0),
    anchor: new window.google.maps.Point(15, 15)
  };

  const onClickMarker = (e) => {
    e.stopPropagation();
    //e.preventDefault();
    console_log(`onClickMarker marker:::`, marker);
    onClick(marker);
  }

  return (
    <>
      <OverlayView
        position={position}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        getPixelPositionOffset={(width, height) => ({
          x: -(width / 2),
          y: -(height / 2),
        })}
        clusterer={clusterer}
      >
        <div style={{ position: 'absolute', textAlign: 'center', left: '-60px', pointerEvents: "auto" }} title={label}>
          <div onClick={(e) => onClickMarker(e)} style={{ display: 'inline-block', width: '48px', backgroundColor: 'transparent', border: '1px solid #4e00f5', padding: '4px', borderRadius: '1000px', overflow: 'hidden' }}>
            <div style={{ backgroundColor: '#ffffff', padding: '4px', borderRadius: '1000px', overflow: 'hidden' }}>
              <img
                src={customMarkerIcon.url}
                alt={label}
                style={{ width: customMarkerIcon.scaledSize.width, height: customMarkerIcon.scaledSize.height }}
              />
            </div>
          </div>

          <p onClick={(e) => onClickMarker(e)} style={{ marginTop: '1px', fontSize: "12px", fontWeight: "400", color: '#111111', textShadow: '1px 2px 0px rgba(255,255,255,1)', width: "120px" }}>{label}</p>
        </div>
      </OverlayView>
    </>
  );
}

export default DeviceMarker;
